
import { forEach } from 'lodash-es'
import { Component as VueComponent } from 'vue'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import SettingDrawer from './components/setting-drawer/SettingDrawer.vue'
import MainLayoutHeader from './components/MainLayoutHeader.vue'
import ReuseTab from './components/reuse-tab/ReuseTab.vue'
import MainBread from './components/MainBread.vue'
import { useReuseTabStore } from '@/store/reuse-tab'
import { useSettingStore } from '@/store/setting'
import { Tooltip, BackTop } from 'ant-design-vue'

const layouts = require.context(
  // 其组件目录的相对路径
  './buildin-layout',
  // 是否查询其子目录
  true,
  // 匹配基础组件文件名的正则表达式
  /\w+\.vue?$/,
)

const laytousMap: { [key: string]: VueComponent } = {}

layouts.keys().map((fileName) => {
  const component = layouts(fileName).default
  laytousMap[component?.extendOptions?.name || component?.options.name || component.name] = component
})

@Component({
  name: 'MainLayout',
  components: {
    SettingDrawer,
    ReuseTab,
    MainLayoutHeader,
    ...laytousMap,
    MainBread,
    ABackTop: BackTop,
    ATooltip: Tooltip,
  },
})
export default class extends Vue {
  // 页面背景颜色
  private bgColor = '#fff'
  private settingStore = useSettingStore()
  private reuseTabStore = useReuseTabStore()
  // 复用tab列表
  private get tabList() {
    forEach(this.reuseTabStore.source, (item) => {
      return item
    })
    return this.reuseTabStore.source
  }
  /**
   * 点击复用tab标签跳转路由
   */
  private handleChangePath(e: any, route: any) {
    if (
      typeof route !== 'undefined' &&
      (route.path !== this.$route.path || route.name !== this.reuseTabStore.to.name)
    ) {
      this.reuseTabStore.changeTo(route)
      this.$router.push(route)
    }
  }

  /**
   * 处理关闭路由tab
   */
  private handleCloseTab(e, route) {
    const activeName = this.reuseTabStore.to?.name
    this.reuseTabStore.remove({
      ...route,
      activeName,
    })
  }

  /**
   * 监控 路由tab to属性，以便正确调整路由
   */
  @Watch('reuseTabStore.to')
  private watchReuseTabTo(newVal: string) {
    if (newVal != undefined && newVal != null) {
      this.handleChangePath(null, newVal)
    }
  }

  /**
   * 监控路由
   */
  @Watch('$route', {
    immediate: true,
  })
  private watchRoute(route: Route) {
    this.bgColor = route?.meta?.backgroundColor || '#fff'
  }
  // 微应用切换布局重载
  @Watch('settingStore.layoutMode')
  private layoutModeChange() {
    location.reload()
  }

  protected mounted() {
    document.body.addEventListener('keyup', this.listenEnter, false)
  }

  private listenEnter(e) {
    if (e.key === 'Enter') {
      // 分页跳转回车导致触发请求搜索
      const isPageSearch = e.path[1]?.classList.contains('ant-pagination-options-quick-jumper')
      const btn = document.querySelector('.standard-search-page .ant-form .ant-btn-primary')

      if (btn && !isPageSearch) {
        btn.dispatchEvent(new Event('click'))
      }
    }
  }

  private beforeDestroy() {
    document.body.removeEventListener('keyup', this.listenEnter, false)
  }
}
